module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pdf-view"
  }, [_c('div', {
    staticClass: "pdf-view-actions"
  }, [_c('div', {
    staticClass: "pdf-view-page"
  }, [_c('span', [_vm._v("Página: "), _c('span', [_vm._v(_vm._s(_vm.page_num))]), _vm._v(" / "), _c('span', [_vm._v(" " + _vm._s(_vm.page_count))])])]), _vm._v(" "), _c('div', {
    staticClass: "pdf-view-buttons"
  }, [_c('v-btn', {
    attrs: {
      "type": "button",
      "disabled": _vm.page_num == 1
    },
    on: {
      "click": _vm.onPrevPage
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v(" Anterior")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "button",
      "disabled": _vm.page_num == _vm.page_count
    },
    on: {
      "click": _vm.onNextPage
    }
  }, [_vm._v("Siguiente "), _c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.descargar(_vm.url)
      }
    }
  }, [_c('v-icon', [_vm._v("file_download")]), _vm._v(" Descargar\n      ")], 1)], 1)]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": _vm.id
    }
  }, [_vm._v("Cargando PDF espere por favor...")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05a9e308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/util/pdf/PdfView.vue
// module id = 491
// module chunks = 2